enum OrderItemTypeEnum
{
    PHYSICAL = "PHYSICAL",
    DISCOUNT = "DISCOUNT",
    SHIPPING_FEE = "SHIPPING_FEE",
    SALES_TAX = "SALES_TAX",
    DIGITAL = "DIGITAL",
    GIFT_CARD = "GIFT_CARD",
    STORE_CREDIT = "STORE_CREDIT",
    FEE = "FEE",
    INSURANCE = "INSURANCE",
}

export default OrderItemTypeEnum;
